import { PAGE_SHAPE } from 'src/views/Management/Reports/types'
import styled from 'styled-components'

export const Content = styled.div<{ pageShape: PAGE_SHAPE }>`
  height: ${({ pageShape }) =>
    `${pageShape.height - (36 + 45 + 21)}${pageShape.unit}`};
`

export const Page = styled.div<{ pageShape: PAGE_SHAPE }>`
  display: block;
  background: white;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  margin: 0 auto;
  margin-bottom: 24px;
  padding: 36px 36px 45px 36px;
  height: ${({ pageShape }) => `${pageShape.height}${pageShape.unit}`};
  width: ${({ pageShape }) => `${pageShape.width}${pageShape.unit}`};

  @media print {
    border: none;
    box-shadow: none;
    margin: 0;
    height: ${({ pageShape }) => `${pageShape.height - 1}${pageShape.unit}`};
    @page {
      margin: 0;
    }
  }
`
